export abstract class StringUtils {
	public static isNullOrEmpty(value: string | null | undefined): boolean {
		return value === null || value === undefined || value.trim?.() === "";
	}

	public static isNotNullOrEmpty(value: string | null | undefined): boolean {
		return value !== null && value !== undefined && value.trim?.() !== "";
	}
}

function capitalize(str: string): string {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

function sanitizeCpfCnpj(input: string): string {
	return input.replace(/[^0-9]/g, "");
}

function formatCompanyTaxpayerRegistration(
	companyTaxpayerRegistration: string
): string {
	return companyTaxpayerRegistration.length >= 14
		? sanitizeCpfCnpj(companyTaxpayerRegistration)
		: "";
}

function unmaskCpfCnpj(cpfCnpj: string): string {
	return sanitizeCpfCnpj(cpfCnpj);
}

function formatCnpjOrCpf(cnpjOrCpf: string): string {
	if (!cnpjOrCpf) return "—";
	const cleaned = cnpjOrCpf.replace(/\D/g, "");
	if (cleaned.length === 11) {
		return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
	} else if (cleaned.length === 14) {
		return cleaned.replace(
			/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
			"$1.$2.$3/$4-$5"
		);
	}
	return cnpjOrCpf;
}

function isNumberFormat(value: string): boolean {
	return /^\d{1,3}(\.\d{3})*(,\d{2})?$/.test(value);
}

function formatNumber(value: string): string {
	if (isNumberFormat(value)) {
		return value.replace(/\./g, "").replace(",", ".");
	}
	return value;
}

export {
	capitalize,
	formatCompanyTaxpayerRegistration,
	unmaskCpfCnpj,
	formatCnpjOrCpf,
	formatNumber,
	isNumberFormat
};
